export const setPriceColor = (realtyOfferId: number, activePin?: number) => {
  const pricePin = document.getElementById(String(realtyOfferId));

  if (!pricePin) {
    return;
  }

  if (realtyOfferId === activePin) {
    pricePin.style.backgroundColor = 'var(--accent-main-primary)';
    pricePin.style.color = 'white';
  } else {
    pricePin.style.backgroundColor = 'white';
    pricePin.style.color = 'black';
  }
};
